module.exports = __webpack_public_path__ + "img/symbol_19_normal.6720e84b.png";